/**
 * PPD Deserializer - Reconstructs Map/Set objects from CDN-served JSON
 *
 * The server-side PPD generator serializes JavaScript Map and Set objects
 * as tagged JSON: {__type: "Map", entries: [...]} and {__type: "Set", values: [...]}.
 * This deserializer uses JSON.parse with a reviver to reconstruct them.
 *
 * @see Phase 2B: Server-Side PPD Generation + CDN Delivery
 */
(function (window) {
  window.MurphyDoorConfigurator = window.MurphyDoorConfigurator || {};

  window.MurphyDoorConfigurator.ppdDeserializer = {
    /**
     * Parse a CDN JSON string, reconstructing Maps and Sets from tagged objects.
     * @param {string} jsonString - JSON string from S3/CDN
     * @returns {Object} PPD with real Map and Set instances
     */
    parse: function (jsonString) {
      return JSON.parse(jsonString, function (_key, value) {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          if (value.__type === 'Map' && Array.isArray(value.entries)) {
            return new Map(
              value.entries.map(function (pair) {
                // Entries are already revived by the inner recursion of JSON.parse
                return pair;
              })
            );
          }
          if (value.__type === 'Set' && Array.isArray(value.values)) {
            return new Set(value.values);
          }
        }
        return value;
      });
    },
  };
})(window);
